// extracted by mini-css-extract-plugin
var _1 = "DepositFiatSelectStyle-module__deposit-fiat-select___ji36v";
var _2 = "DepositFiatSelectStyle-module__deposit-fiat-select___ji36v";
var _3 = "DepositFiatSelectStyle-module__fiat-options___ikrg3";
var _4 = "DepositFiatSelectStyle-module__fiat-options___ikrg3";
var _5 = "DepositFiatSelectStyle-module__headline___t9FZ3";
var _6 = "DepositFiatSelectStyle-module__notice___Zyb3O";
var _7 = "DepositFiatSelectStyle-module__radio___KO0TO";
var _8 = "DepositFiatSelectStyle-module__tooltip___MTwXp";
export { _1 as "deposit-fiat-select", _2 as "depositFiatSelect", _3 as "fiat-options", _4 as "fiatOptions", _5 as "headline", _6 as "notice", _7 as "radio", _8 as "tooltip" }
